const mutations = {
  setWhatsapp(state, data) {
    state.whatsappEdit = data
  },
  setDeleteWhatsapp(state, data) {
    state.whatsappDelete = data
  }
}

export default mutations